import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, setLanguage } from '../../i18n';

/**
 * 화면 언어 선택 — 고른 값은 localStorage(openflow_lang)에 남아 다음에 열 때도 그 언어로 시작한다.
 * 언어 이름(한국어 / English)은 번역하지 않는다 — 읽지 못하는 언어로 적혀 있으면 되돌아올 수 없다.
 */
const LanguageSelect: React.FC<{ className?: string }> = ({ className }) => {
  const { t, i18n } = useTranslation();
  const current = SUPPORTED_LANGUAGES.some((l) => l.code === i18n.language) ? i18n.language : 'ko';
  return (
    <select
      value={current}
      onChange={(e) => setLanguage(e.target.value)}
      title={t('common:language.label')}
      aria-label={t('common:language.label')}
      className={`rounded-md border border-gray-200 bg-white px-1.5 py-1 text-xs text-gray-600 hover:bg-gray-50 ${className || ''}`}
    >
      {SUPPORTED_LANGUAGES.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
    </select>
  );
};

export default LanguageSelect;
